var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { omit, filter, every, isString, isArray, map, find, xor, isEmpty } from "lodash";
import Select from "react-select";
import Creatable from "react-select/creatable";
import Orderable from "react-select-draggable";
import { ValidationInput } from "@irati/utils/validation";
import newId from "@irati/utils/id";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import { FormGroup } from "@irati/ui/src/Form";
import ErrorText from "@irati/ui/src/ErrorText";
import HintText from "@irati/ui/src/HintText";
import Label from "./styled/Label";
import perkboxStyles from "./styles/selectStyles";
import SelectOptionComponent from "./SelectOption";
import SelectValueComponent from "./SelectValue";
import SelectPillComponent from "./SelectPill";
var FormItemSelect = /** @class */ (function (_super) {
    __extends(FormItemSelect, _super);
    function FormItemSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function () {
            _this.validation.update(_this.props, _this.state);
            if (typeof _this.props.onBlur === "function") {
                _this.props.onBlur();
            }
        };
        _this.handleChange = function (option) {
            var _a = _this.props, isMulti = _a.isMulti, onChange = _a.onChange;
            var value = isMulti ? [] : null;
            if (option) {
                if (isMulti) {
                    value = option.map(function (multiOption) {
                        return __assign(__assign({}, multiOption), { label: _this.getOptionLabel(multiOption), value: _this.getOptionValue(multiOption) });
                    });
                }
                else {
                    value = _this.getOptionValue(option);
                }
            }
            _this.setState({ value: value });
            onChange(value, option);
        };
        _this.mapValueToOptions = function () {
            var options = _this.props.options;
            var value = _this.state.value;
            if (isArray(value) && isArray(options) && options.length > 0) {
                if (every(value, isString)) {
                    return map(value, function (selectedValue) {
                        return (find(options, function (_a) {
                            var optionValue = _a.value;
                            return optionValue === selectedValue;
                        }) || {
                            // created new entry
                            label: selectedValue,
                            value: selectedValue
                        });
                    });
                }
                return value;
            }
            return undefined;
        };
        _this.setValue = function () {
            var _a = _this.props, options = _a.options, isMulti = _a.isMulti;
            if (isMulti) {
                var value_1 = _this.state.value;
                return value_1 && every(value_1, isString) ? _this.mapValueToOptions() : value_1;
            }
            var value = _this.props.value;
            return (typeof value === "string" || typeof value === "boolean") && options
                ? filter(options, function (_a) {
                    var optionValue = _a.value;
                    return optionValue === value;
                })
                : value;
        };
        _this.getOptionLabel = function (option) {
            var _a = _this.props, _b = _a.labelKey, labelKey = _b === void 0 ? "label" : _b, _c = _a.getOptionLabel, getOptionLabel = _c === void 0 ? function () { return option[labelKey]; } : _c;
            return getOptionLabel(option);
        };
        _this.getOptionValue = function (option) {
            var _a = _this.props, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.getOptionValue, getOptionValue = _c === void 0 ? function () { return option[valueKey]; } : _c;
            return getOptionValue(option);
        };
        _this.state = {
            errorMsg: undefined,
            blurred: false
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    FormItemSelect.getDerivedStateFromProps = function (props, state) {
        var propsValue = props.value;
        var stateValue = state.value;
        if ((isString(propsValue) && propsValue !== stateValue) ||
            isEmpty(stateValue) ||
            (isArray(propsValue) && (isArray(stateValue) && xor(propsValue, stateValue).length > 0))) {
            return {
                value: propsValue
            };
        }
        return null;
    };
    FormItemSelect.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    FormItemSelect.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    FormItemSelect.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, className = _a.className, hint = _a.hint, id = _a.id, promptTextCreator = _a.promptTextCreator, hideLabel = _a.hideLabel, onInputChange = _a.onInputChange, components = _a.components, isCreatable = _a.isCreatable, isDisabled = _a.isDisabled, isOrderable = _a.isOrderable;
        var errorMsg = this.state.errorMsg;
        var selectProps = omit(this.props, ["className", "label", "validation", "formatMessage", "translate"]);
        var props = __assign(__assign({ style: { border: "1px solid #979797" } }, selectProps), { id: newId("select", id || name), name: newId("select", id || name), value: this.setValue(), onChange: this.handleChange, onBlur: this.handleBlur, onInputChange: onInputChange, getOptionLabel: this.getOptionLabel, getOptionValue: this.getOptionValue, isDisabled: isDisabled });
        return (React.createElement(FormGroup, { className: className, controlId: name, validationState: errorMsg ? "error" : undefined },
            label && (React.createElement(Col, { xs: 12, hidden: hideLabel },
                React.createElement(Label, { id: newId("label", id || name), error: errorMsg, htmlFor: name, flush: true }, getResolvedMessage(this, "label")))),
            React.createElement(Col, { xs: 12 },
                isCreatable && (React.createElement(Creatable, __assign({}, props, { placeholder: getResolvedMessage(this, "placeholder"), promptTextCreator: promptTextCreator, components: __assign({ Option: SelectOptionComponent, SingleValue: SelectValueComponent, MultiValueLabel: SelectPillComponent, IndicatorSeparator: function () { return null; } }, components), styles: perkboxStyles }))),
                !isCreatable &&
                    (isOrderable ? (React.createElement(Orderable, __assign({}, props, { styles: perkboxStyles }))) : (React.createElement(Select, __assign({}, props, { placeholder: getResolvedMessage(this, "placeholder"), components: __assign({ Option: SelectOptionComponent, SingleValue: SelectValueComponent, MultiValueLabel: SelectPillComponent, IndicatorSeparator: function () { return null; } }, components), styles: perkboxStyles })))),
                errorMsg && (React.createElement("div", null,
                    React.createElement(ErrorText, { small: true }, getResolvedMessage(this, "errorMsg", this.state)))),
                hint && (React.createElement("div", null,
                    React.createElement(HintText, { small: true }, hint))))));
    };
    FormItemSelect.contextTypes = {
        currentScreen: PropTypes.string
    };
    FormItemSelect.defaultProps = {
        hideLabel: false,
        labelKey: "label",
        valueKey: "value",
        promptTextCreator: function (label) { return "Create option " + label; },
        isCreatable: false,
        isDisabled: false
    };
    return FormItemSelect;
}(Component));
export { FormItemSelect };
export default injectIntl(FormItemSelect);
